import { render, staticRenderFns } from "./AccordionTrigger.vue?vue&type=template&id=2ddeaa98&scoped=true"
import script from "./AccordionTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionTrigger.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccordionTrigger.vue?vue&type=style&index=0&id=2ddeaa98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddeaa98",
  null
  
)

export default component.exports